import React from "react";
import PropTypes from 'prop-types';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

class GeneralInput extends Base {
	input() {
		const { id, inputValue, type } = this.props;
		
		return(
			<input type={ type } id={ id } name={ id } value={ inputValue } onChange={ ( e ) => {
				this.onChange( e.target.value );
			} } />
		);
	}
}


GeneralInput.propTypes = {
	id: PropTypes.string,
	type: PropTypes.string,
	inputValue: PropTypes.string,
};
GeneralInput.defaultProps = {
	type: 'text'
};

export default withInput( GeneralInput );
